import React from 'react';
import { Link } from 'react-router-dom';

export default () => (
  <div className="modal__content">
    <h3>Update Billing Info</h3>
    <p>
      Your billing information is out of date, please <Link to="/subscription/billing">update it</Link>.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/UpdateBillingContent.js